export default {
  title: 'שיוך לסוכן קיים',
  subtitle: 'בחר סוכן קיים לשיוך ההסכם אליו:',
  searchPlaceholder: 'חפש לפי שם או ת.ז.',
  actions: {
    confirm: 'אשר שיוך',
    cancel: 'ביטול',
  },
  notification: {
    fetchError: { title: 'שגיאה', message: 'לא ניתן לטעון סוכנים' },
    reassignError: { title: 'שגיאה', message: 'לא ניתן לבצע את השיוך, נסה שנית' },
  },
};
